// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__-S20I","active":"NavbarItem_active__tsUmq"};